import { Injectable, inject, signal, computed } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private translate = inject(TranslateService);
  
  // Signal for current language
  public currentLanguage = signal<string>('en');
  
  // Computed signal for reactive components
  public languageChanged = computed(() => this.currentLanguage());

  constructor() {
    // Set the default and fallback language
    this.translate.setDefaultLang('en');
    
    // Initialize with saved language or default to 'en'
    const savedLanguage = localStorage.getItem('language') || 'en';
    this.setLanguage(savedLanguage);
  }

  setLanguage(languageCode: string): void {
    console.log(`[LanguageService] Setting language to: ${languageCode}`);
    this.currentLanguage.set(languageCode);
    this.translate.use(languageCode).subscribe({
      next: (translations) => {
        console.log(`[LanguageService] Successfully loaded translations for ${languageCode}:`, Object.keys(translations).slice(0, 5));
        localStorage.setItem('language', languageCode);
      },
      error: (err) => {
        console.error(`[LanguageService] Error loading translations for ${languageCode}:`, err);
      }
    });
  }

  getCurrentLanguage(): string {
    return this.currentLanguage();
  }
}
